import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { VueFire, VueFireAuth } from 'vuefire'

import './style.sass'

import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { firebaseApp } from './firebase'

const app = createApp(App);
const pinia = createPinia();

app
    .use(pinia)
    .use(router)
    .use(i18n)
    .use(VueFire, {
        firebaseApp,
        modules: [
            VueFireAuth(),
        ],
    })
    .mount('#app');